/*
  KNOPS live zoeken (suggesties tijdens het typen)
  ------------------------------------------------
  Eén gedeeld script voor alle Knops-pagina's:
  - Elk zoekveld in een ".kp-search-panel" (header-zoekpaneel op de pagina's)
    en elk veld met [data-kp-live] (de grote zoekbalk op de resultatenpagina)
    krijgt direct onder zich een lijst met projecten (en collecties) terwijl je typt.
  - Gebruikt templates/search.suggest.liquid (JSON via /search?view=suggest),
    met dezelfde prioriteit als de resultatenpagina: tag, anders beschrijving, anders titel.
  - Pijltjestoetsen + Enter + Escape werken; Enter zonder keuze opent de
    volledige resultatenpagina.
  - Alle zoekformulieren zoeken alleen in projecten (type=product), zodat de
    resultatenpagina overal hetzelfde telt en toont.
*/
(function () {
  if (window.__kpLiveSearch) return;
  window.__kpLiveSearch = true;

  var MIN_CHARS = 2;
  var DELAY = 180;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // Vertaalbare teksten komen uit window.KP_I18N (gezet in knops-sidebar-menu.liquid via locale-bestanden).
  var I = window.KP_I18N || {};
  function tx(key, fallback, q) { return String(I[key] || fallback).replace('__Q__', q == null ? '' : q).replace('{{ q }}', q == null ? '' : q); }

  var css = [
    '.kp-ls{margin-top:.6rem;background:#0f0f0f;border:1px solid rgba(255,255,255,.1);border-radius:12px;overflow:hidden;',
    'box-shadow:0 18px 50px rgba(0,0,0,.45);font-family:"Poppins",-apple-system,BlinkMacSystemFont,sans-serif;color:#fff;text-align:left;',
    'opacity:0;transform:translateY(-6px);visibility:hidden;pointer-events:none;',
    'transition:opacity .2s ease,transform .2s ease,visibility 0s linear .2s;}',
    '.kp-ls.is-open{opacity:1;transform:none;visibility:visible;pointer-events:auto;transition:opacity .2s ease,transform .2s ease,visibility 0s;}',
    '.kp-ls--overlay{position:absolute;left:0;right:0;top:100%;z-index:60;margin-top:.7rem;}',
    '.kp-ls__label{display:block;padding:.7rem 1rem .25rem;font-size:10.5px;letter-spacing:.14em;text-transform:uppercase;color:#cc9f5a;font-weight:600;}',
    '.kp-ls__item{display:flex;align-items:center;gap:.8rem;padding:.55rem 1rem;color:#fff;text-decoration:none;transition:background .15s ease;}',
    '.kp-ls__item:hover,.kp-ls__item.is-active{background:rgba(204,159,90,.14);}',
    '.kp-ls__thumb{flex:0 0 auto;width:52px;height:40px;border-radius:5px;overflow:hidden;background:#1b1b1b;}',
    '.kp-ls__thumb img{width:100%;height:100%;object-fit:cover;display:block;}',
    '.kp-ls__text{display:flex;flex-direction:column;min-width:0;}',
    '.kp-ls__title{font-size:14px;font-weight:400;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.kp-ls__title mark{background:none;color:#cc9f5a;font-weight:500;}',
    '.kp-ls__sub{font-size:11.5px;color:rgba(255,255,255,.5);}',
    '.kp-ls__all{display:block;padding:.8rem 1rem;border-top:1px solid rgba(255,255,255,.08);font-size:12.5px;letter-spacing:.04em;',
    'color:#cc9f5a;text-decoration:none;text-transform:uppercase;font-weight:500;}',
    '.kp-ls__all:hover,.kp-ls__all.is-active{background:rgba(204,159,90,.14);}',
    '.kp-ls__new{position:relative;overflow:hidden;flex:0 0 auto;margin-left:auto;display:inline-flex;align-items:center;background:linear-gradient(135deg,#cc9f5a 0%,#fddaa1 100%);color:#1a1305;font-family:Oswald,sans-serif;font-weight:600;font-size:10px;letter-spacing:.12em;line-height:1;padding:4px 8px 5px;border-radius:999px;box-shadow:0 0 10px rgba(253,218,161,.45);}',
    '.kp-ls__new::after{content:"";position:absolute;top:0;left:-60%;width:45%;height:100%;background:linear-gradient(115deg,rgba(255,255,255,0) 0%,rgba(255,255,255,.85) 50%,rgba(255,255,255,0) 100%);transform:skewX(-20deg);animation:kp-ls-shine 3.2s ease-in-out infinite;}',
    '@keyframes kp-ls-shine{0%{left:-60%}28%{left:130%}100%{left:130%}}',
    '.kp-ls__empty{padding:.9rem 1rem;font-size:13px;color:rgba(255,255,255,.6);}'
  ].join('');
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function highlight(text, q) {
    var safe = esc(text);
    if (!q) return safe;
    var parts = q.trim().split(/\s+/).filter(Boolean).map(function (w) {
      return esc(w).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    if (!parts.length) return safe;
    return safe.replace(new RegExp('(' + parts.join('|') + ')', 'ig'), '<mark>$1</mark>');
  }
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }
  function resultsUrl(q) {
    return root + 'search?type=product&q=' + encodeURIComponent(q);
  }

  // Alle zoekformulieren: alleen projecten doorzoeken.
  function forceProductType(form) {
    if (!form || form.querySelector('input[name="type"]')) return;
    var h = document.createElement('input');
    h.type = 'hidden'; h.name = 'type'; h.value = 'product';
    form.appendChild(h);
  }

  function attach(input) {
    if (input.__kpLs) return;
    input.__kpLs = true;
    input.setAttribute('autocomplete', 'off');
    var form = input.form || input.closest('form');
    forceProductType(form);

    var overlay = input.hasAttribute('data-kp-live-overlay');
    var box = document.createElement('div');
    box.className = 'kp-ls' + (overlay ? ' kp-ls--overlay' : '');
    box.setAttribute('role', 'listbox');
    if (overlay) {
      (input.closest('[data-kp-live-wrap]') || input.parentNode).appendChild(box);
    } else if (form) {
      form.insertAdjacentElement('afterend', box);
    } else {
      input.insertAdjacentElement('afterend', box);
    }

    var timer = null, ctrl = null, lastQ = '', active = -1;

    function links() { return Array.prototype.slice.call(box.querySelectorAll('a')); }
    function setActive(i) {
      var l = links();
      l.forEach(function (a, n) { a.classList.toggle('is-active', n === i); });
      active = i;
    }
    function open() { box.classList.add('is-open'); }
    function close() { box.classList.remove('is-open'); active = -1; }

    function render(q, data) {
      var products = (data && data.products) || [];
      var total = (data && data.count) || 0;
      var html = '';
      if (products.length) {
        html += '<span class="kp-ls__label">' + esc(tx('projects', 'Projecten')) + '</span>';
        products.forEach(function (p) {
          html += '<a class="kp-ls__item" role="option" href="' + esc(p.url) + '">' +
            '<span class="kp-ls__thumb">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="kp-ls__text"><span class="kp-ls__title">' + highlight(p.title, q) + '</span>' +
            '<span class="kp-ls__sub">' + (p.code ? esc(tx('project', 'Project')) + ' ' + esc(p.code) : esc(tx('project', 'Project'))) + '</span></span>' +
            (p['new'] ? '<span class="kp-ls__new">NEW</span>' : '') + '</a>';
        });
      } else {
        html += '<div class="kp-ls__empty">' + esc(tx('none', 'Geen projecten gevonden voor “{{ q }}”.', q)) + '</div>';
      }
      var more = total > products.length ? ' (' + total + ')' : '';
      html += '<a class="kp-ls__all" href="' + esc(resultsUrl(q)) + '">' + esc(tx('all_results', 'Alle resultaten voor “{{ q }}”', q)) + more + ' &rarr;</a>';
      box.innerHTML = html;
      active = -1;
      open();
    }

    function run(q) {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      // Zelfde zoeklogica als de resultatenpagina: tag eerst, anders beschrijving,
      // anders titel (templates/search.suggest.liquid).
      var url = root + 'search?view=suggest&type=product&q=' + encodeURIComponent(q);
      fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && input.value.trim() === q) render(q, d); })
        .catch(function () {});
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < MIN_CHARS) { close(); lastQ = ''; return; }
      if (q === lastQ) { open(); return; }
      lastQ = q;
      timer = setTimeout(function () { run(q); }, DELAY);
    });
    input.addEventListener('focus', function () {
      if (box.innerHTML && input.value.trim().length >= MIN_CHARS) open();
    });
    input.addEventListener('keydown', function (e) {
      var l = links();
      if (e.key === 'Escape') { close(); return; }
      if (!box.classList.contains('is-open') || !l.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive((active + 1) % l.length); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive((active - 1 + l.length) % l.length); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); window.location.href = l[active].href; }
    });
    document.addEventListener('click', function (e) {
      if (!box.contains(e.target) && e.target !== input) close();
    });
  }

  /* ---- Favorieten-teller op het hartje in de header (alle pagina's) ---- */
  (function () {
    var KEY = 'kp_favorites';
    var st = document.createElement('style');
    st.textContent = '.kp-favbadge{position:absolute;top:-5px;right:-7px;min-width:17px;height:17px;padding:0 4px;border-radius:999px;' +
      'background:linear-gradient(135deg,#cc9f5a,#fddaa1);color:#000;font:600 10.5px/17px "Poppins",sans-serif;text-align:center;' +
      'pointer-events:none;transform:scale(0);transition:transform .25s cubic-bezier(.2,.9,.3,1.4);}' +
      '.kp-favbadge.is-on{transform:scale(1);}';
    document.head.appendChild(st);
    function count() {
      try { return (JSON.parse(window.localStorage.getItem(KEY) || '[]') || []).length; } catch (e) { return 0; }
    }
    function update() {
      var n = count();
      document.querySelectorAll('a.kp-header__icon[href*="favorieten"], a.kp-header__icon[aria-label="Favorieten"]').forEach(function (a) {
        var b = a.querySelector('.kp-favbadge');
        if (!b) {
          if (window.getComputedStyle(a).position === 'static') a.style.position = 'relative';
          b = document.createElement('span'); b.className = 'kp-favbadge'; a.appendChild(b);
        }
        b.textContent = n > 99 ? '99+' : n;
        b.classList.toggle('is-on', n > 0);
      });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-fav-toggle]')) setTimeout(update, 60);
    });
    window.addEventListener('storage', update);
    window.addEventListener('pageshow', update);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
    setTimeout(update, 700);
    setInterval(update, 1500);
  })();

  /* ---- Globale, subtiele zoekbalk (vervangt de zwarte zoekbalk op alle pagina's) ---- */
  (function () {
    var st = document.createElement('style');
    st.textContent = '.kp-search-panel{display:none!important}' +
      '.kp-gs{position:fixed;z-index:100000;height:46px;width:min(340px,86vw);opacity:0;visibility:hidden;transform:translateY(-4px);' +
      'transition:opacity .2s ease,transform .2s ease,visibility 0s linear .2s;font-family:"Poppins",-apple-system,BlinkMacSystemFont,sans-serif;}' +
      '.kp-gs.is-open{opacity:1;visibility:visible;transform:none;transition:opacity .2s ease,transform .2s ease,visibility 0s;}' +
      '.kp-gs__form{position:relative;display:flex;align-items:center;height:100%;margin:0;padding:0 .4rem 0 1.15rem;border-radius:999px;transition:border-color .2s ease,box-shadow .2s ease,background .2s ease;' +
      'background:rgba(20,20,20,.55);border:1px solid rgba(255,255,255,.16);-webkit-backdrop-filter:blur(14px);backdrop-filter:blur(14px);}' +
      '.kp-gs__form:focus-within{border-color:rgba(204,159,90,.85);background:rgba(14,14,14,.78);box-shadow:0 0 0 4px rgba(204,159,90,.12),0 10px 30px rgba(0,0,0,.35);}' +
      '.kp-gs .kp-gs__input,.kp-gs .kp-gs__input:hover,.kp-gs .kp-gs__input:focus,.kp-gs .kp-gs__input:focus-visible,.kp-gs .kp-gs__input:active{flex:1;min-width:0;width:auto;height:100%;margin:0;padding:0;background:transparent!important;border:0!important;border-radius:0!important;outline:none!important;box-shadow:none!important;-webkit-appearance:none;appearance:none;color:#fff;caret-color:#cc9f5a;font:300 14px/1 "Poppins",sans-serif;letter-spacing:.01em;}' +
      '.kp-gs .kp-gs__input::-webkit-search-cancel-button,.kp-gs .kp-gs__input::-webkit-search-decoration{-webkit-appearance:none;display:none;}' +
      '.kp-gs .kp-gs__btn,.kp-gs .kp-gs__btn:focus{outline:none!important;box-shadow:none!important;border:0!important;background:none!important;}' +
      '.kp-gs .kp-gs__btn:hover{color:#cc9f5a;}' +
      '.kp-gs .kp-gs__btn:focus-visible{outline:2px solid #cc9f5a!important;outline-offset:-4px;border-radius:50%!important;}' +
      '.kp-gs__input::placeholder{color:rgba(255,255,255,.72);}' +
      '.kp-gs__btn{flex:0 0 auto;width:38px;height:38px;display:flex;align-items:center;justify-content:center;background:none;border:0;color:#fff;cursor:pointer;padding:0;}' +
      '.kp-gs__btn svg{width:20px;height:20px;}' +
      '.kp-gs .kp-ls--overlay{margin-top:.5rem;}' +
      '.kp-gs__pop a{display:block;padding:.62rem 1rem;color:#fff;text-decoration:none;font-size:14px;border-top:1px solid rgba(255,255,255,.06);}' +
      '.kp-gs__pop a:hover{background:rgba(204,159,90,.14);}';
    document.head.appendChild(st);

    var gs = null, input = null, pop = null, trigger = null;
    function build() {
      if (gs) return;
      gs = document.createElement('div');
      gs.className = 'kp-gs';
      gs.setAttribute('data-kp-live-wrap', '');
      gs.setAttribute('role', 'search');
      gs.innerHTML = '<form class="kp-gs__form" action="' + root + 'search" method="get">' +
        '<input class="kp-gs__input" type="search" name="q" autocomplete="off" data-kp-live-overlay placeholder="' + esc(tx('placeholder', 'Search your dream garden')) + '" aria-label="' + esc(tx('placeholder', 'Search your dream garden')) + '">' +
        '<button type="submit" class="kp-gs__btn" aria-label="Search"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg></button></form>';
      document.body.appendChild(gs);
      input = gs.querySelector('input');
      forceProductType(gs.querySelector('form'));
      attach(input);
      var terms = String(tx('popular_terms', '')).split(',').map(function (t) { return t.trim(); }).filter(Boolean);
      if (terms.length) {
        pop = document.createElement('div');
        pop.className = 'kp-ls kp-ls--overlay kp-gs__pop';
        pop.innerHTML = '<span class="kp-ls__label">' + esc(tx('popular', 'Popular')) + '</span>' + terms.map(function (t) {
          return '<a href="' + esc(resultsUrl(t)) + '">' + esc(t) + '</a>';
        }).join('');
        gs.appendChild(pop);
      }
      function sync() { if (pop) pop.classList.toggle('is-open', gs.classList.contains('is-open') && !input.value.trim()); }
      input.addEventListener('input', sync);
      input.addEventListener('focus', sync);
      gs.__sync = sync;
    }
    function place() {
      if (!gs || !trigger) return;
      var r = trigger.getBoundingClientRect();
      var w = gs.offsetWidth || 340;
      var right = Math.min(window.innerWidth - 8, r.right + 6);
      gs.style.left = Math.max(8, right - w) + 'px';
      gs.style.top = Math.max(6, r.top + r.height / 2 - 23) + 'px';
    }
    function setOpen(o) {
      build();
      gs.classList.toggle('is-open', o);
      if (o) { place(); setTimeout(function () { input.focus(); }, 30); }
      gs.__sync();
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-open-search]');
      if (t) {
        /* Telefoon (feedback Erik 30-10): direct naar de zoekpagina, geen tussenstap met uitklapveld. */
        if (window.matchMedia && window.matchMedia('(max-width: 600px)').matches) {
          e.preventDefault(); e.stopPropagation();
          window.location.href = root + 'search';
          return;
        }
        e.preventDefault(); e.stopPropagation();
        trigger = t;
        build();
        setOpen(!gs.classList.contains('is-open'));
        return;
      }
      if (gs && gs.classList.contains('is-open') && !gs.contains(e.target)) setOpen(false);
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && gs && gs.classList.contains('is-open')) setOpen(false); });
    window.addEventListener('resize', place);
    window.addEventListener('scroll', function () { if (gs && gs.classList.contains('is-open')) place(); }, { passive: true });
  })();


  /* ---- Alle "Let's meet"/contactknoppen wijzen naar de Meet now-pagina (/pages/meetnow) ---- */
  (function () {
    var TARGET = root + 'pages/meetnow';
    function fix(scope) {
      if (!document.querySelector('.kp-header')) return; // Signature-pagina's blijven onaangetast
      var sc = scope || document;
      // Oude contactlink en oude meetnow-link (met behoud van ?project=...)
      sc.querySelectorAll('a[href*="/pages/contact"], a[href*="/pages/meet-now"]').forEach(function (a) {
        if (a.closest('.kp-sb, nav, footer')) return;
        if (a.hasAttribute('data-keep-contact')) return;
        var u = a.getAttribute('href') || '';
        if (/\/pages\/meet-now(?:[?#]|$)/.test(u)) a.setAttribute('href', u.replace('/pages/meet-now', '/pages/meetnow'));
        else if (/\/pages\/contact(?:[?#]|$)/.test(u)) a.setAttribute('href', TARGET);
      });
      // De gouden Let's meet-knop in de header gaat altijd naar Meet now, wat er ook in de editor staat
      sc.querySelectorAll('.kp-header__cta').forEach(function (a) {
        if (a.hasAttribute('data-keep-contact')) return;
        if ((a.getAttribute('href') || '').indexOf('/pages/meetnow') === -1) a.setAttribute('href', TARGET);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fix(); });
    else fix();
    window.addEventListener('pageshow', function () { fix(); });
  })();

  function init() {
    document.querySelectorAll('form[action$="/search"]').forEach(forceProductType);
    document.querySelectorAll('.kp-search-panel input[name="q"], input[data-kp-live]').forEach(attach);
    // Zoekpanelen kunnen later in beeld komen; opnieuw koppelen als ze opengaan.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-open-search]')) {
        setTimeout(function () {
          document.querySelectorAll('.kp-search-panel input[name="q"]').forEach(attach);
        }, 0);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---- Het gouden logo linksboven gaat naar de nieuwe homepage: dezelfde link als het Home-icoon in de zijbalk ---- */
(function () {
  function homeHref() {
    var links = document.querySelectorAll('.kp-sb__link');
    for (var i = 0; i < links.length; i++) {
      var l = links[i], lab = l.querySelector('.kp-sb__label');
      var t = ((lab ? lab.textContent : l.textContent) || '').trim().toLowerCase();
      if (t === 'home' || t === 'homepage') return l.getAttribute('href');
    }
    return null;
  }
  function fix() {
    var h = homeHref();
    if (!h) return;
    document.querySelectorAll('.kp-header__logo').forEach(function (a) { a.setAttribute('href', h); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
  window.addEventListener('load', fix);
})();
